module.exports = __webpack_public_path__ + "static/media/Hardware hacker meet up.b026a6a0.png";